import { getUrlByPathname } from 'consts/APIUrls';
import { useEffect } from 'react'
import { createAPI } from 'services/api/api';
import useProfile from './useProfile';
import { useLocation } from 'react-router-dom';

const useFiltersData = (setFilters, setIsFiltersLoading) => {

  const {pathname} = useLocation();
  const {token} = useProfile();

  return useEffect(() => {
    const api = createAPI();

    const fetchFilters = () => {
      if ((!pathname.includes('/dashboard') && !pathname.includes('/card-pack-open')) && token) {
        setIsFiltersLoading(true)
        api.get(`${getUrlByPathname(pathname).filters}`)
          .then((res) => {

            setFilters(() => {
              const filteredData = res.data.data.filter((filter) => filter.filter.length > 0 && filter.filter !== null)
              return {total: res.data.total, data: filteredData}
            });
          })
          .catch((error) => console.log('useFiltersDataError' ,error))
          .finally(() => setIsFiltersLoading(false))
      }
    }

    if (token) {
      fetchFilters();
    } else {
      setFilters(null);
    }

    return () => {
      setFilters(null)
    }
  }, [token, pathname])
}

export default useFiltersData;
